import React, { useEffect, useState } from "react";
import axios from "../../api/axios";
import Navbar from "../navsidebar/navbar";
import Sidebar from "../navsidebar/sidebar";

const RetailCategoryTable = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const { businessEntityId: business_entity_id } = JSON.parse(sessionStorage.getItem("userData"));

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`retail/getTodayCategoryTotals/${business_entity_id}`);
        setData(response.data);
        setLoading(false);
      } catch (err) {
        setError("Failed to load data");
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) return <p className="text-center mt-4">Loading...</p>;
  if (error) return <p className="text-center text-danger mt-4">{error}</p>;

  return (
    <div className="d-flex vh-100 bg-light">
      <Sidebar />
      <div className="d-flex flex-column w-100">
        <Navbar />
        <div className="container-fluid p-4">
          <div className="table-responsive">
            <table className="table table-bordered table-hover shadow-sm">
              <thead className="table-light">
                <tr>
                  <th className="py-3">Category Name</th>
                  <th className="py-3">Quantity Sold</th>
                  <th className="py-3">Total Sales (₹)</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, index) => (
                  <tr key={index}>
                    <td className="py-3">{item.category_name}</td>
                    <td className="py-3">{item.total_quantity}</td>
                    <td className="py-3">₹{item.total_order_amount}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RetailCategoryTable;
